(function () {
  var SELECTOR = 'button[aria-label="Vertrag widerrufen"]';
  var BUTTON_CLASS = 'withdrawal-button-custom';
  var ICON_CLASS = 'withdrawal-button-custom__icon';
  var watchedButtons = new WeakSet();
  var ICON =
    '<svg class="' + ICON_CLASS + '" aria-hidden="true" width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M9.5 3.75V5.75C9.5 5.8163 9.47366 5.87989 9.42678 5.92678C9.37989 5.97366 9.3163 6 9.25 6H3.85375L4.92688 7.07312C4.97379 7.12004 5.00014 7.18366 5.00014 7.25C5.00014 7.31634 4.97379 7.37996 4.92688 7.42688C4.87996 7.47379 4.81634 7.50014 4.75 7.50014C4.68366 7.50014 4.62004 7.47379 4.57312 7.42688L3.07312 5.92688C3.04988 5.90366 3.03144 5.87609 3.01886 5.84574C3.00628 5.81539 2.9998 5.78285 2.9998 5.75C2.9998 5.71715 3.00628 5.68461 3.01886 5.65426C3.03144 5.62391 3.04988 5.59634 3.07312 5.57312L4.57312 4.07312C4.59635 4.0499 4.62393 4.03147 4.65428 4.0189C4.68462 4.00633 4.71715 3.99986 4.75 3.99986C4.78285 3.99986 4.81538 4.00633 4.84572 4.0189C4.87607 4.03147 4.90365 4.0499 4.92688 4.07312C4.9501 4.09635 4.96853 4.12393 4.9811 4.15428C4.99367 4.18462 5.00014 4.21715 5.00014 4.25C5.00014 4.28285 4.99367 4.31538 4.9811 4.34572C4.96853 4.37607 4.9501 4.40365 4.92688 4.42688L3.85375 5.5H9V3.75C9 3.6837 9.02634 3.62011 9.07322 3.57322C9.12011 3.52634 9.1837 3.5 9.25 3.5C9.3163 3.5 9.37989 3.52634 9.42678 3.57322C9.47366 3.62011 9.5 3.6837 9.5 3.75ZM12.5 0.75V9.75C12.5 9.94891 12.421 10.1397 12.2803 10.2803C12.1397 10.421 11.9489 10.5 11.75 10.5H0.75C0.551088 10.5 0.360322 10.421 0.21967 10.2803C0.0790177 10.1397 0 9.94891 0 9.75V0.75C0 0.551088 0.0790177 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H11.75C11.9489 0 12.1397 0.0790175 12.2803 0.21967C12.421 0.360322 12.5 0.551088 12.5 0.75ZM12 0.75C12 0.683696 11.9737 0.620107 11.9268 0.573223C11.8799 0.526339 11.8163 0.5 11.75 0.5H0.75C0.683696 0.5 0.620107 0.526339 0.573223 0.573223C0.526339 0.620107 0.5 0.683696 0.5 0.75V9.75C0.5 9.8163 0.526339 9.87989 0.573223 9.92678C0.620107 9.97366 0.683696 10 0.75 10H11.75C11.8163 10 11.8799 9.97366 11.9268 9.92678C11.9737 9.87989 12 9.8163 12 9.75V0.75Z" fill="currentColor" stroke="currentColor" stroke-width="0.18" stroke-linejoin="round"/>' +
    '</svg>';

  function enhanceButton(button) {
    if (!button.classList.contains(BUTTON_CLASS)) {
      button.classList.add(BUTTON_CLASS);
    }

    if (!button.querySelector('.' + ICON_CLASS)) {
      button.insertAdjacentHTML('afterbegin', ICON);
    }
  }

  function watchButton(button) {
    enhanceButton(button);

    if (watchedButtons.has(button)) return;
    watchedButtons.add(button);

    new MutationObserver(function () {
      enhanceButton(button);
    }).observe(button, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });
  }

  var existing = document.querySelector(SELECTOR);
  if (existing) {
    watchButton(existing);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) {
          watchButton(node);
        } else if (node.querySelector) {
          var found = node.querySelector(SELECTOR);
          if (found) watchButton(found);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
